import React, { useState, useEffect } from "react";
import useAxios from "../hooks/useAxios";

export function withAxiosHOC(Component) {
  return function WrappedComponent(props) {
    const [loading, sendRequest] = useAxios();
    return <Component {...props} loading={loading} sendRequest={sendRequest} />;
  };
}
